var map = {
	"./MBudget.svg": 1161,
	"./Mtel.svg": 1116,
	"./Quickline.svg": 1114,
	"./Salt.svg": 1111,
	"./Spusu.svg": 1117,
	"./Swisscom.svg": 1109,
	"./TalkTalk.svg": 1115,
	"./Wingo.svg": 1110,
	"./migros.svg": 1113,
	"./yallo.svg": 1112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1160;